import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { FetchHandlerModule } from 'nallian-shared-ui/lib/modules';
import communityTextService from '../services/communityText';
import { FETCH_SHAPE } from '../../app/lib/propTypeShapes';
import Markdown from '../../app/components/Markdown';

const CommunityText = ({
  communityTextFetch,
  myCommunityFetch,
  t,
  language,
  communityTag,
  dispatchCommunityTextGet,
}) => {
  useEffect(() => {
    dispatchCommunityTextGet(communityTag, language);
  }, [dispatchCommunityTextGet, communityTag, language]);

  return (
    <FetchHandlerModule fetches={[communityTextFetch, myCommunityFetch]} handleLoading>
      {communityTextFetch.value ? (
        <Markdown markdown={communityTextFetch.value.contents} />
      ) : (
        <>{t('noCommunityData')}</>
      )}
    </FetchHandlerModule>
  );
};

CommunityText.propTypes = {
  communityTextFetch: FETCH_SHAPE.isRequired,
  myCommunityFetch: FETCH_SHAPE.isRequired,
  dispatchCommunityTextGet: PropTypes.func.isRequired,
  language: PropTypes.string,
  communityTag: PropTypes.string,
  t: PropTypes.func.isRequired,
};

CommunityText.defaultProps = {
  language: undefined,
  communityTag: undefined,
};

export default compose(communityTextService, withTranslation(['app', 'shared']))(CommunityText);
